/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/p': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9.584 13.552v4.491h-2.1V5.957h4.624c1.35 0 2.421.351 3.212 1.054.797.703 1.196 1.633 1.196 2.79 0 1.184-.39 2.105-1.17 2.764-.776.658-1.863.987-3.263.987H9.584zm0-1.685h2.524c.747 0 1.317-.174 1.71-.523.393-.354.59-.863.59-1.527 0-.653-.2-1.173-.598-1.56-.399-.394-.947-.596-1.644-.607H9.584v4.217z" _fill="currentColor"/>'
  }
})
